export const START_PULLS_LOAD = 'START_PULLS_LOAD'
export const SET_PULLS_RESULT = 'SET_PULLS_RESULT'
export const NETWORK_ERROR = 'NETWORK_ERROR'

export const UPDATE_CONFIG = 'UPDATE_CONFIG'
